import { getPurchaseRecordList } from '@/api/domain/organize'
import { useDictParseList } from '@/utils/useUtils'
import { operateMaxShowLength } from '@/store/dict/config'

const INVOICE_STATE = {
  INVOICING: 1,
  INVOICE_SUCCESS: 2,
  INVOICE_FAIL: 3,
}

const PURCHASE_STATE = {
  PROCESSING: 0,
  COMPLETE: 1,
  FAIL: 2,
}

const purchaseStateList = {
  0: '处理中',
  1: '完成',
  2: '失败',
}

const invoiceTypeList = {
  1: '电子普票',
  2: '电子专票',
}

const invoiceStateList = {
  1: '开票中',
  2: '开票成功',
  3: '开票失败',
}


const getConfigData = (vm, downloadInvoiceFile, handlePurchaseInvoice, baseListManagementRef) => {
  return {
    formData: {
      list: [
        {
          el: 'date-picker',
          itemConfig: {
            label: '提交日期',
            prop: 'gmtCreateDate',
          },
        },
        {
          el: 'input',
          itemConfig: {
            label: '企业主体全称',
            prop: 'orgName',
          },
          elConfig: {
            clearable: true,
            placeholder: '请输入企业主体全称',
            maxlength: 50,
            style: {
              width: '230px',
            },
            events: {
              input: (value) => {
                baseListManagementRef.value.setItemData({
                  elConfigKey: 'value', key: 'orgName', data: value,
                })
              },
            },
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '状态',
            prop: 'purchaseState',
          },
          elConfig: {
            options: {
              label: 'label',
              value: 'value',
              list: useDictParseList(purchaseStateList, true),
            },
          },
        },
      ],
      customizeReset: () => {
        baseListManagementRef.value.setItemData({
          elConfigKey: 'value', key: 'orgName', data: '',
        })
      },
    },
    tableData: {
      columns: [
        {
          name: 'gmtCreate',
          columnProps: {
            prop: 'gmtCreate',
            label: '提交时间',
          },
        },
        {
          name: 'orgName',
          columnProps: {
            prop: 'orgName',
            label: '企业主体全称',
          },
        },
        {
          name: 'orgIdCardNum',
          columnProps: {
            prop: 'orgIdCardNum',
            label: '统一社会信用代码',
          },
        },
        {
          name: 'purchaseQuantity',
          columnProps: {
            prop: 'purchaseQuantity',
            label: '购买份额数',
          },
        },
        {
          name: 'purchaseAmount',
          columnProps: {
            prop: 'purchaseAmount',
            label: '付款金额',
          },
        },
        {
          name: 'purchaseAttachment',
          columnProps: {
            prop: 'purchaseAttachment',
            label: '付款凭证',
            width: '150px',
          },
          render: ({ row }) => {
            if (row.purchaseAttachment) {
              const purchaseAttachment = JSON.parse(row.purchaseAttachment)
              return (
                purchaseAttachment.map((item) => {
                  return vm.$createElement('div', {
                    style: {
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    },
                  }, [
                    vm.$createElement('a', {
                      attrs: {
                        href: item,
                        target: '_blank',
                      },
                    }, `${vm.getFileName(item)}`),
                  ])
                })
              )
            }
            return '--'
          },
        },
        {
          name: 'invoiceType',
          columnProps: {
            prop: 'invoiceType',
            label: '开票类型',
          },
          getText: ({ row }) => {
            return invoiceTypeList[row.invoiceType]
          },
        },
        {
          name: 'purchaseState',
          columnProps: {
            prop: 'purchaseState',
            label: '份额分配状态',
          },
          render: ({ row }) => {
            if (row.purchaseState === PURCHASE_STATE.FAIL) {
              return vm.$createElement('el-tooltip', {
                props: {
                  placement: 'top',
                },
              }, [
                vm.$createElement('div', {
                  slot: 'content',
                }, row.remark),
                vm.$createElement('span', [
                  purchaseStateList[row.purchaseState],
                  vm.$createElement('i', {
                    class: 'el-icon-question',
                  }),
                ]),
              ])
            }
            return purchaseStateList[row.purchaseState]
          },
        },
        {
          name: 'invoiceState',
          columnProps: {
            prop: 'invoiceState',
            label: '开票状态',
          },
          getText: ({ row }) => {
            return invoiceStateList[row.invoiceState]
          },
        },
        {
          name: 'expireDate',
          columnProps: {
            prop: 'expireDate',
            label: '份额失效日期',
          },
        },
        {
          name: 'operate',
          columnProps: {
            label: '操作',
            prop: 'operate',
            fixed: 'right',
            width: 240,
          },
          maxShowLength: operateMaxShowLength,
          getOperateList: ({ row }) => {
            const resultBtn = [
              {
                name: 'download_invoice',
                label: '下载发票',
                action: () => downloadInvoiceFile(row),
                permission: row.invoiceState === INVOICE_STATE.INVOICE_SUCCESS && vm.judgePermission('download_invoice'),
              },
              {
                name: 'purchase_invoice',
                label: '申请开票',
                action: () => handlePurchaseInvoice(row),
                permission: row.invoiceState === INVOICE_STATE.INVOICE_FAIL && vm.judgePermission('purchase_invoice'),
              },
            ]
            return resultBtn.filter((i) => i.permission)
          },
          type: 'operate',
        },
      ],
      apiFn: (params) => {
        const [gmtCreateDateFrom = '', gmtCreateDateTo = ''] = params.gmtCreateDate || []
        return getPurchaseRecordList({
          ...params,
          gmtCreateDateFrom,
          gmtCreateDateTo,
        })
      },
    },
    isShowDepartment: false,
  }
}

export { getConfigData, INVOICE_STATE, invoiceTypeList }
